// client/src/styles/app/theme/mixins.js

import theme from './theme';

const mixins = {
  // Flexbox helpers
  flexCenter: `
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  
  flexBetween: `
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,

  // Media queries
  mediaQuery: (breakpoint) => `@media (min-width: ${theme.breakpoints[breakpoint]})`,

  // Typography
  ellipsis: `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,

  // Transitions
  defaultTransition: (properties = 'all') => `
    transition: ${properties} ${theme.transitions.base};
  `,

  // Box shadows
  hoverShadow: `
    transition: box-shadow ${theme.transitions.base};
    &:hover {
      box-shadow: ${theme.shadows.md};
    }
  `,

  // Responsive container
  container: `
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-left: ${theme.container.padding.sm};
    padding-right: ${theme.container.padding.sm};
    
    @media (min-width: ${theme.breakpoints.sm}) {
      max-width: ${theme.container.maxWidth.sm};
    }
    
    @media (min-width: ${theme.breakpoints.md}) {
      max-width: ${theme.container.maxWidth.md};
    }
    
    @media (min-width: ${theme.breakpoints.lg}) {
      max-width: ${theme.container.maxWidth.lg};
      padding-left: ${theme.container.padding.lg};
      padding-right: ${theme.container.padding.lg};
    }
    
    @media (min-width: ${theme.breakpoints.xl}) {
      max-width: ${theme.container.maxWidth.xl};
    }
  `,

  // Grid system
  grid: (columns = 12, gap = 4) => `
    display: grid;
    grid-template-columns: repeat(${columns}, 1fr);
    gap: ${theme.spacing[gap]};
  `
};

export default mixins;